<template>
    <div v-if="!success" class="waiting">
        <div class="waiting__text" v-html="$t('template.paymentSuccess.waiting')"></div>
        <loader></loader>
    </div>
    <payment-success :timer="redirectTimer" v-else></payment-success>
</template>

<script>
import PaymentSuccess from '@/components/auth/paymentSuccess';
import CheckoutService from '@/services/CheckoutService.ts';
import Loader from '@/components/loader';
export default {
    name: 'PaymentSuccessPage',
    components: { Loader, PaymentSuccess },
    data() {
        return {
            success: false,
            requestInterval: null,
            sessionId: null,
            redirectTimer: 10,
            redirectInterval: null,
        };
    },
    mounted() {
        this.sessionId = localStorage.getItem('sessionId');
        this.requestInterval = setInterval(this.checkPayment, 3000);
    },
    methods: {
        async checkPayment() {
            const [error, result] = await CheckoutService.checkSuccess(this.sessionId);
            if (error) {
                clearInterval(this.requestInterval);
                error.notify();
                return;
            }
            const { checkoutStatus } = result;
            if (checkoutStatus === 'COMPLETE') {
                clearInterval(this.requestInterval);
                this.success = true;
                localStorage.removeItem('sessionId');
                localStorage.removeItem('sessionIdExpiredAt');
                this.handlePaymentSuccess();
            }
        },

        handlePaymentSuccess() {
            const initialTimerValue = this.redirectTimer;
            this.redirectInterval = setInterval(() => {
                this.redirectTimer = --this.redirectTimer;
            }, 1000);
            console.log(initialTimerValue);
            setTimeout(this.startBuildingCheck, initialTimerValue * 1000);
        },

        startBuildingCheck() {
            clearInterval(this.redirectInterval);
            this.$router.push({ name: 'Building' });
        },
    },
    beforeUnmounted() {
        clearInterval(this.requestInterval);
        clearInterval(this.redirectInterval);
    },
};
</script>

<style lang="scss">
.waiting {
    display: flex;
    height: 300px;
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 54px;
    margin-top: 60px;
    &__text {
        font-size: 18px;
        text-align: center;
    }
}
</style>
